<template>
    <div id="tvbet-frame" class="bng-live-casino"></div>
</template>
<script>
import Vue from 'vue';

import tvbet from './frame.js';

export default {
    name: 'tvbet',
    data() {
        return {
            frame: null
        }
    },
    computed: {
        lang() {
            return Vue.state.lang.currentLang;
        },
        session() {
            return Vue.state.tvbet.session.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        }
    },
    watch: {
        async lang(newVal, oldVal) {
            if (newVal != oldVal) {
                await this.resetFrame();
            }
        }
    },
    async mounted() {
        await this.resetFrame();
    },
    methods: {
        async resetFrame() {
            document.getElementById('tvbet-frame').innerHTML = "";
            await Vue.state.player.ensure();
            if (this.isLoggedIn) {
                await Vue.state.tvbet.session.open();
            } else {
                await Vue.state.tvbet.session.openDemo();
            }
            this.frame = tvbet.TvbetFrame({
                lng: this.lang,
                clientId: this.session.clientId,
                tokenAuth: this.session.token,
                server: this.session.server,
                page: this.session.startPage,
                containerId: 'tvbet-frame'
            });
        }
    },
    async beforeDestroy(){
        this.frame && this.frame.removeListeners();
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/live-casino/live-casino.vue